import React from 'react';
import styled from 'styled-components';
import BaseButton from './BaseButton';
import { RFC } from 'state/StateTypes';
import { useDispatch } from 'react-redux';
import { updateAsset } from 'state/assets/AssetActions';
import { Link } from '@reach/router';

interface Props {
   title: string;
   active?: boolean;
   loading: boolean;
   _id?: string;
   onDelete?: () => void;
}

const DetailHeader: RFC<Props> = ({ title, active, loading, _id, onDelete }) => {
   const dispatch = useDispatch();
   const toggleStatus = async (active: boolean) => {
      await dispatch(updateAsset({ active: !active, _id }));
   };
   const nonEditableViews = ['customer detail', 'admin detail'];
   return (
      <Container>
         <DetailTitle>{title.toLocaleUpperCase()}</DetailTitle>
         {!loading && (
            <ButtonContainer>
               {!nonEditableViews.includes(title) && (
                  <Link to={`${window.location.pathname}/edit`}>
                     <EditButton>Edit</EditButton>
                  </Link>
               )}
               {active !== undefined && <ActionButton onClick={() => toggleStatus(active)}>{active ? 'Deactivate' : 'Activate'}</ActionButton>}
               {!nonEditableViews.includes(title) && <DeleteButton onClick={onDelete}>Delete</DeleteButton>}
            </ButtonContainer>
         )}
      </Container>
   );
};

export default DetailHeader;

const Container = styled.div`
   display: flex;
   flex-wrap: wrap;
   justify-content: space-between;
   flex-direction: row;
   align-items: center;
`;

const DetailTitle = styled.h2`
   font-weight: 700;
   font-size: 2em;
   color: ${({ theme }) => theme.primaryBlueDark};
   padding: 5px;
   margin-right: 5px;
`;

const ActionButton = styled(BaseButton)`
   width: auto;
   padding: 10px 15px;
   margin: unset;
`;

const DeleteButton = styled(ActionButton)`
   background-color: ${({ theme }) => theme.secondaryRed};

   &:hover {
      background-color: ${({ theme }) => theme.primaryRed};
   }
`;

const EditButton = styled(ActionButton)`
   background-color: ${({ theme }) => theme.secondaryBlueLight};
   &:hover {
      background-color: ${({ theme }) => theme.secondaryBlueDark};
   }
`;

const ButtonContainer = styled.div`
   display: flex;
   flex-flow: row;
   > * {
      margin: 0 5px;
   }
`;
